<template>
	<div>
		<el-card>
			<div slot="header" style="display: inline-block;float: left;font-weight: bolder;font-size: 24px;">{{$t('lang.lab_DoorDeviceSonManege')}}</div>
			<el-button type="primary" slot="header" @click="add">{{$t('lang.lab_addDoorDeviceSon')}}</el-button>
			<!-- 子门禁表格 -->
			<el-table :data="list" class="wid100" :height="list.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="name" :label="$t('lang.lab_nameDoorDeviceSon')"></el-table-column>
				<el-table-column prop="num" :label="$t('lang.lab_numDoorDeviceSon')"></el-table-column>
				<el-table-column prop="createTime" :label="$t('lang.lab_ctDoorDeviceSon')">
					<template slot-scope="scope">
						{{scope.row.createTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="operTime" :label="$t('lang.lab_otDoorDeviceSon')">
					<template slot-scope="scope">
						{{scope.row.operTime | time}}
					</template>
				</el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="150px">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						&nbsp;
						<el-popconfirm :confirmButtonText="$t('lang.btn_confirm')" :cancelButtonText="$t('lang.btn_cancel')" icon="el-icon-info"
							iconColor="red" title="是否删除？" @onConfirm="del(scope.row.id)">
							<el-button class="orange" slot="reference">{{$t('lang.btn_delete')}}</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 添加子门禁dialog -->
		<el-dialog :title="$t('lang.lab_addDoorDeviceSon')" :visible.sync="addDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="doorDeviceSonForm" :rules="rules" ref="doorDeviceSonForm">
				<el-form-item :label="$t('lang.lab_nameDoorDeviceSon')" label-width="120px" prop="name">
					<el-input v-model="doorDeviceSonForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_numDoorDeviceSon')" label-width="120px" prop="num">
					<el-input v-model="doorDeviceSonForm.num" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="addDoorDeviceSon(doorDeviceSonForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
		<!-- 修改子门禁dialog -->
		<el-dialog :title="$t('lang.lab_editDoorDeviceSon')" :visible.sync="editDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="doorDeviceSonForm" :rules="rules" ref="doorDeviceSonForm">
				<el-form-item :label="$t('lang.lab_nameDoorDeviceSon')" label-width="120px" prop="name">
					<el-input v-model="doorDeviceSonForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_numDoorDeviceSon')" label-width="120px" prop="num">
					<el-input v-model="doorDeviceSonForm.num" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="editDoorDeviceSon(doorDeviceSonForm)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				doorDeviceId: '',
				list: [],

				addDialogFormVisible: false,
				doorDeviceSonForm: {
					id: '',
					name: '',
					num: ''
				},

				editDialogFormVisible: false,

				rules: {
					name: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_nameDoorDeviceSon'),
						trigger: 'blur'
					}],
					num: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_numDoorDeviceSon'),
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.doorDeviceId = this.$route.query.id
			this.selectList()
		},
		methods: {
			selectList() {
				let loading = this.$loading()
				this.$get(`doorDeviceSon/?doorDeviceId=` + this.doorDeviceId + `&pageNo=1&pageSize=99`)
					.then(response => {
						// console.log(response);
						this.list = response.list
						loading.close()
					})
					.catch(error => {
						console.log(error)
					})
			},
			add() {
				this.addDialogFormVisible = true
				this.doorDeviceSonForm.name = ''
				this.doorDeviceSonForm.num = ''
			},
			addDoorDeviceSon(doorDeviceSonForm) {
				this.$refs.doorDeviceSonForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							doorDeviceId: this.doorDeviceId,
							name: doorDeviceSonForm.name,
							num: doorDeviceSonForm.num
						}
						this.$post(`/addDoorDeviceSon`, param)
							.then(response => {
								// console.log(response);
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.addDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								loading.close()
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			edit(row) {
				this.editDialogFormVisible = true
				this.doorDeviceSonForm.id = row.id
				this.doorDeviceSonForm.name = row.name
				this.doorDeviceSonForm.num = row.num
				// console.log(row)
			},
			editDoorDeviceSon(doorDeviceSonForm) {
				this.$refs.doorDeviceSonForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							doorDeviceId: this.doorDeviceId,
							name: doorDeviceSonForm.name,
							num: doorDeviceSonForm.num
						}
						this.$patch(`/doorDeviceSon/` + this.doorDeviceSonForm.id, param)
							.then(response => {
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.editDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								this.$message.error(this.$i18n.t('lang.resourEditLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			del(id) {
				let loading = this.$loading()
				this.$delete(`/deldoorDeviceSon/` + id)
					.then(response => {
						if (response && response.errCode === 0) {
							this.$message({
								type: 'success',
								message: this.$i18n.t('lang.lab_del_success')
							})
							this.selectList()
							loading.close()
						}
					})
					.catch(error => {
						this.$message({
							type: 'error',
							message: this.$i18n.t('lang.lab_del_fail')
						})
						loading.close()
						console.log(error)
					})
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>
